import React from 'react';
import { HotkeysProvider, useHotkeysContext } from 'react-hotkeys-hook';
import { KeyboardScope } from '@/platform/shortcuts/operator-shortcuts';
import { SalesPortalKeyboardScope } from '@/experiences/sales-portal/platform/shortcuts/sales-portal-shortcuts';

interface Props {
  children: React.ReactNode;
  // string needed for "*" wildcard. ref: https://github.com/JohannesKlauss/react-hotkeys-hook
  scopes: Array<SalesPortalKeyboardScope | KeyboardScope | string>;
}

export const KeyboardShortcutsProvider: React.FC<Props> = ({
  children,
  scopes,
}) => (
  <HotkeysProvider initiallyActiveScopes={scopes}>{children}</HotkeysProvider>
);

export const useKeyboardHotkeysContext = useHotkeysContext;
